import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPackageCkeck: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPackageCkeck"><Path d="M8 3H3V21H13.7574L10.5074 17.75L14.75 13.5073L16.5 15.2573L21 10.7573V3H16V9H8V3Z" fill="currentColor"/><Path d="M14 3H10V7H14V3Z" fill="currentColor"/><Path d="M16.5 20.9142L21.9142 15.5L20.5 14.0858L16.5 18.0858L14.75 16.3358L13.3358 17.75L16.5 20.9142Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPackageCkeck;
